module.exports = __webpack_public_path__ + "img/embajada-noruega.29178c84.png";